// $(window).on("load", function () {
// 	$('#map-control-dropdown-toggle').on('click', function(event){
// 		event.preventDefault();
// 		$('#map-control-dropdown').addClass('active');
// 	})

// 	$('#overlay-close').on('click', function(event){
// 		$('#map-control-dropdown').removeClass('active');
// 	});
// });
